import { useEffect, useState } from "react";
import { taskService } from "@miplatform/api";
import { ACTIVITY_CARD_CONFIG, HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { buildActivityDateFilter } from "@miplatform/utils";

export const useHomeActivityDrawerViewModel = ({ home, open, search }) => {
  const stateManager = useComponentState();
  const [homeOrderActivities, setHomeOrderActivities] = useState([]);
  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null,
  });

  useEffect(() => {
    const fetchActivities = async (id) => {
      return stateManager.run(async () => {
        const { status, data = [] } = await taskService.activities.getByHomeId({
          id,
          filters: buildActivityDateFilter(dateRange),
        });

        if (status === HTTP_STATUSES.OK) {
          setHomeOrderActivities(data);
          return data;
        }
        return [];
      });
    };

    if (open && home?.id) {
      fetchActivities(home.id);
    }
  }, [open, home?.id, dateRange]);

  const handleDateRangeChange = (newRange) => {
    setDateRange(newRange);
  };

  const filteredOrderActivities = homeOrderActivities.filter((activity) => {
    const { notes, reason, activityType, orderTemplateName, createdByUser } =
      activity || {};

    const searchLower = search.toLowerCase();

    return (
      createdByUser?.displayName?.toLowerCase().includes(searchLower) ||
      createdByUser?.tenantName?.toLowerCase().includes(searchLower) ||
      notes?.toLowerCase().includes(searchLower) ||
      reason?.toLowerCase().includes(searchLower) ||
      orderTemplateName?.toLowerCase().includes(searchLower) ||
      ACTIVITY_CARD_CONFIG[activityType]?.title
        ?.toLowerCase()
        ?.includes(searchLower)
    );
  });

  return {
    homeOrderActivities,
    filteredOrderActivities,
    dateRange,
    handleDateRangeChange,
    isLoading: stateManager.isBusy(),
  };
};
